import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { 
  toggleRenewalModal, 
  toggleSubscribeModal,
  allowToSub 
} from "../../redux/actions/renewalActions";
import strings from "../../strings";
import { Button, Modal, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import NewSubscriptionModal from "../StripePayment/NewSubscriptionModal";

const milisecondsToDaysConst = 86400000;
const TRIAL_PERIOD_DAYS = 14; // 14-day free trial

const SubscriptionNotification = ({ 
  user, 
  toggleRenewalModal, 
  allowToSub 
}) => {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [trialExpired, setTrialExpired] = useState(false);
  const history = useHistory();
  
  const business = user?.employer ? { ...user.employer } : { ...user };

  const daysLeft = Math.ceil(
    (new Date(business?.subscription_expires_on) - Date.now()) /
      milisecondsToDaysConst
  );

  // Check if trial has expired for Free plan users
  useEffect(() => {
    if (user?.id && business?.subscription_plan === "Free" && daysLeft <= 0) {
      setTrialExpired(true);
      // Auto-show subscription modal when trial expires - DISABLED
      // setShowSubscriptionModal(true);
    }
  }, [user?.id, business?.subscription_plan, daysLeft]);

  const isAdmin = user?.role_id && user.role_id === 1;

  const handleUpgradeClick = () => {
    setShowSubscriptionModal(true);
  };

  const handleSubscriptionModalClose = () => {
    // If trial has expired, don't allow closing the modal
    if (trialExpired) {
      return;
    }
    setShowSubscriptionModal(false);
  };

  // Auth guard: do not render if user unauthenticated (after all hooks)
  if (!user || !user.id) {
    return null;
  }

  // Calculate trial days used and remaining (for 14-day trial)
  const trialDaysRemaining = business.subscription_plan === "Free" ? Math.max(0, daysLeft) : 0;
  const isInTrialPeriod = business.subscription_plan === "Free" && trialDaysRemaining > 0;

  const style = {
    margin: "5px",
    height: "60%",
    padding: "2px 15px",
    background: "#70C274",
    border: "0",
    borderRadius: "5px",
    outline: "none",
    cursor: "pointer",
  };

  const upgradeBtn = (
    <Button type="primary" style={style} onClick={handleUpgradeClick}>
      {strings.upgrade || "Upgrade"}
    </Button>
  );

  const renewBtn = (
    <Button type="primary" style={style} onClick={handleUpgradeClick}>
      {strings.renew || "Renew"}
    </Button>
  );

  // Determine banner content based on subscription status
  let banner = null;
  let color = "orange";

  if (business.subscription_plan === "Free") {
    if (trialDaysRemaining > 7) {
      // During active trial period (more than 7 days left)
      color = "#4CAF50"; // Green for active trial
      banner = (
        <span style={{ color: "#fff", textAlign: "center" }}>
          🎉 You're on a {TRIAL_PERIOD_DAYS}-day Free Trial! {trialDaysRemaining} days remaining.{" "}
          Click {upgradeBtn} to unlock full features.
        </span>
      );
    } else if (trialDaysRemaining > 0) {
      // Trial ending soon (7 days or less remaining)
      color = "#f6cb34"; // Yellow/warning
      banner = (
        <span style={{ color: "#fff", textAlign: "center" }}>
          ⚠️ Your free trial ends in {trialDaysRemaining} {trialDaysRemaining === 1 ? "day" : "days"}!{" "}
          Click {upgradeBtn} to continue using Loystar.
        </span>
      );
    } else {
      // Trial expired
      color = "#fb929c"; // Red for expired
      banner = (
        <span style={{ color: "#fff", textAlign: "center" }}>
          ⏰ Your free trial has expired. Click {upgradeBtn} to subscribe and continue using Loystar.
        </span>
      );
    }
  } else if (daysLeft <= 7 && daysLeft > 0) {
    // Paid subscription expiring soon
    color = "#f6cb34";
    banner = (
      <span style={{ color: "#fff", textAlign: "center" }}>
        {strings.yourSubscriptionExpiresIn} {daysLeft} {strings.days}.{" "}
        {strings.clickOn} {renewBtn} {strings.to} {strings.renew}{" "}
        {strings.yourPlanInFewSteps?.replace(".", "") || "your plan in a few steps"}
      </span>
    );
  } else if (daysLeft <= 0) {
    // Paid subscription expired
    color = "#fb929c";
    banner = (
      <span style={{ color: "#fff", textAlign: "center" }}>
        {strings.yourSubscriptionHasExpired || "Your subscription has expired."} {strings.clickOn} {renewBtn}{" "}
        {strings.to} {strings.renew} {strings.yourPlanInFewSteps?.replace(".", "") || "your plan in a few steps"}
      </span>
    );
  }

  // Hide banner if user has active paid subscription with more than 7 days left
  if (business.subscription_plan !== "Free" && daysLeft > 7) return null;

  // Hide for BeepBeep users
  if (user.ref_code?.toLowerCase() === "beepbeep") return null;

  return (
    <>
      {banner && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            lineHeight: "30px",
            background: color,
            fontSize: "18px",
            padding: "5px 10px",
          }}
        >
          {banner}
        </div>
      )}

      {/* New Subscription Modal */}
      <NewSubscriptionModal
        isOpen={showSubscriptionModal}
        onClose={handleSubscriptionModalClose}
        user={user}
        isUndismissableForFreePlan={trialExpired}
      />
    </>
  );
};

export default connect(null, { 
  toggleRenewalModal, 
  toggleSubscribeModal,
  allowToSub 
})(SubscriptionNotification);
